/* istanbul ignore file - better tested visually */

import { LoadingSpinner } from '@partful/shared/ui/LoadingSpinner/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import styles from './LoadingPage.module.scss';

export function LoadingPage() {
  const { t: i18n } = useTranslation();

  return (
    <div className={styles.loader} role="alert" aria-live="polite" aria-label={i18n('instructions:common.loading')}>
      <LoadingSpinner />
    </div>
  );
}
